import { createExtensionPoint } from '@interhyp/platform-plugin';
export const selfRegisterExtension = createExtensionPoint(Symbol('selfRegisterExtension'));
